<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title>Administración de Libros</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="indigo" outline rounded dark class="mb-2" @click="createLibro">
        <v-icon color="yellow darken-2">add</v-icon>nuevo libro
       </v-btn>
      </v-toolbar>
    <v-data-table :headers="headers" :items="libros" :search="search" class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.titulo }}</td>
        <td>{{ props.item.autores_nombres }}</td>
        <td>{{ props.item.editorial.nombre }}</td>
        <td>{{ props.item.categoria.nombre_categoria }}</td>
        <td>{{ props.item.existencia }}</td>
        <td class="justify-center layout px-0">

          <!--<v-icon medium class="mr-2" @click="prestarItem(props.item)">book</v-icon>!-->

          <!--<v-icon medium class="mr-2" @click="editItem(props.item)">edit</v-icon>!-->
          <v-icon medium @click="openDeleteDialog(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Buscar datos de nuevo</v-btn>
      </template>
    </v-data-table>

    <!--DIALOGO DE ELIMINACION !-->
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-text>
          <v-layout justify-space-around>
            <v-icon x-large color="red" style="font-size: 85px;">report</v-icon>
          </v-layout>
        </v-card-text>
        <v-layout justify-space-around>
          <v-card-title class="title text-md-center">¿Estas seguro de querer eliminar este elemento?</v-card-title>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat small color="error" @click="deleteDialog = false,confirmDelete=false">No</v-btn>

          <v-btn flat="flat" outline small color="green darken-1" @click="deleteItem()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { debuglog } from "util";
export default {
  data: () => ({
    dialog: false,
    deleteDialog: false,
    autores: [],
    autoresList: [],

    confirmDelete: false,
    search: "",
    headers: [
      {
        text: "Título",
        align: "left",
        sortable: true,
        value: "titulo"
      },
      {
        text: "Autores",
        align: "left",
        sortable: true,
        value: "autores_nombres"
      },
      {
        text: "Editorial",
        align: "left",
        sortable: true,
        value: "editorial"
      },
      {
        text: "Categoria",
        align: "left",
        sortable: true,
        value: "categoria"
      },
      {
        text: "Existencia total",
        align: "left",
        sortable: true,
        value: "existencia"
      },
      { text: "Acciones", value: "", sortable: false }
    ],
    libros: [],
    editedIndex: -1,
    editedItem: {
      nombres: "",
      apellidos: ""
    },
    defaultItem: {
      nombres: "",
      apellidos: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Libro" : "Editar Libro";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const that = this;
      this.$store
        .dispatch("getLibros")
        .then(response => {
          setTimeout(function() {
            
            that.libros = that.$store.getters.libro;
            that.pagination = that.$store.state.paginationLibro;
            that.libros.forEach(libro => {
                var existencia = 0;
                let concat_autores = "";
                libro.autores.forEach(element => {
                  concat_autores += element.nombres+" "+element.apellidos+" | ";
                  libro.autores_nombres = concat_autores;
                });
                libro.detalle_libro.forEach(detalle=>{
                    existencia += detalle.existencia;
                });
                libro.existencia = existencia;
            });
            
          }, 500);
        })
        .catch(error => {
          console.log(error);
        });
     
    },

    createLibro(){
        this.$router.push('libroswizard');
    },
    prestarItem(libro){
        this.$router.push({ name: 'newprestamo', params: {libro: libro }});
    },

    openDeleteDialog(item) {
      this.editedIndex = this.libros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },

    editItem(item) {
      this.editedIndex = this.libros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem() {
      const that = this;
      this.$store
        .dispatch("deleteLibro", this.editedItem)
        .then(response => {
          that.initialize();
          that.cancelDelete();
        })
        .catch(error => {
          console.log(error);
        });
    },

    cancelDelete() {
      this.deleteDialog = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.libros[this.editedIndex], this.editedItem);
      } else {
        this.libros.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>